export default __webpack_public_path__ + "static/media/athlete_skeleton.58a29f49.png";